import { render, staticRenderFns } from "./BlockResetPassword.vue?vue&type=template&id=61fa1a74&scoped=true&"
import script from "./BlockResetPassword.vue?vue&type=script&lang=js&"
export * from "./BlockResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./BlockResetPassword.vue?vue&type=style&index=0&id=61fa1a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fa1a74",
  null
  
)

export default component.exports